import { createGetListAction, createUpdateApiAction } from './apiGenerator';
import {
  COLLECTION_DETAILS_API,
  CREATE_MULTI_TEXTURE_RETAIL_AUTO,
  CRUD_RETAIL_AUTOMATION,
  CRUD_RETAIL_AUTOMATION_ARTWORK,
  CRUD_RETAIL_AUTOMATION_ARTWORK_TEXTURE,
  CRUD_RETAIL_AUTOMATION_BULK_CAMERA,
  CRUD_RETAIL_AUTOMATION_CAMERA,
  CRUD_RETAIL_AUTOMATION_HOTSPOT,
  CRUD_RETAIL_AUTOMATION_PRODUCTS,
  CRUD_RETAIL_AUTOMATION_SETS,
  DUPLICATE_ARTWORK,
  DUPLICATE_MULTI_TEXTURE_RETAIL_AUTO,
  OP_GET_ROOMS_API,
  RENDER_ARTWORK,
  DUPLICATE_HOTSPOT_PRODUCT,
  RETAIL_AUTOMATION_PROP_VARIANT_V2,
  RETAIL_AUTOMATION_PROP_VARIANT_LISTING,
  CRUD_RETAIL_AUTOMATION_PRODUCTS_V2,
  PROPS_API_V2,
  CRUD_RETAIL_AUTOMATION_HOTSPOT_PRESIGNED,
  CRUD_RETAIL_AUTOMATION_HOTSPOT_UPDATE,
  PROP_GROUP_API_V2,
} from '../config/constant/apiConstant';
import { retailAutomationListActions } from '../redux/slicers/retailAutomationListSlicer';
import { API_ROOT_URL, apiDeleteV2, apiGet, apiMultiDelete, apiPatch, apiPost, apiPostImageOnPresignedData, apiPostV2, UPDATE_PROPS_API } from '../helpers/api';
import { errorToast, errorToastV2 } from '../helpers/toastHelper';
import {
  retailAutomationActions,
  selectAllTemplates,
} from '../redux/slicers/retailAutomation/retailAutomation.slicer';
import { getAppState } from '../redux/store';
import { fetchAllPages } from '../helpers/apiHelper';
import api from '../helpers/axiosHelper';
import { selectIsCacheUsedInAPI } from '../redux/slicers/appSlicer';
import { clearCacheFromAPI } from '../helpers/jsHelper';
import { ROOM_TYPE } from '../constants/roomConstants';
import { dispatcher } from '../helpers/projectHelper';

export const addTimestampParamInUrl = (url, key, value) => {
  const [base, query = ''] = url.split('?');
  const params = new URLSearchParams(query);

  params.set('_cat', selectIsCacheUsedInAPI(getAppState()));
  return params.toString() ? `${base}?${params.toString()}` : base;
};

export const getRetailAutomationApi = createGetListAction({
  endpoint: CRUD_RETAIL_AUTOMATION,
  actions: retailAutomationListActions,
  setGlobalSidebarFilters: true,
  formatEndpoint: (u) => addTimestampParamInUrl(u),
});

export function createRetailAutomationApi({ name }) {
  const data = {
    name,
  };
  return apiPostV2(CRUD_RETAIL_AUTOMATION, { data }).send();
}

export const getRetailAutomationDetailApi =
  (payload, flag = true) =>
  (dispatch) => {
    const mockDataFetching = async () => {
      const url = `${CRUD_RETAIL_AUTOMATION}${payload.automationId}/`;
      // TODO: add error handling
      const automation = await apiGet(addTimestampParamInUrl(url));
      if (automation) {
        return automation;
      } else {
        return {};
      }
    };
    return mockDataFetching();
  };

export const updateRetailAutomation =
  (data, oldData, toSetData = true) =>
  async (dispatch) => {
    const url = `${CRUD_RETAIL_AUTOMATION}${data.id}/`;
    try {
      const updatedData = await apiPatch(url, data, 'updateRetailAutomation');
      if (!updatedData) {
        throw new Error();
      }
      if (toSetData) {
        dispatch(retailAutomationActions.setData(updatedData));
      }
      return true;
    } catch (error) {
      if (toSetData) {
        dispatch(retailAutomationActions.setData(oldData));
      }
      errorToastV2('Something went wrong! please try again.');
    }
  };

export const deleteRetailAutomationApi = (id) => async (dispatch) => {
  let url = CRUD_RETAIL_AUTOMATION;
  url += `${id}/`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const retailAutomationUpdateApi = createUpdateApiAction({
  actions: retailAutomationListActions,
  endpointUrl: CRUD_RETAIL_AUTOMATION,
});

export const getAllTemplatesForAutomation = async ({ page }, dispatch) => {
  // TODO: add error handling
  const url = `${OP_GET_ROOMS_API}?per_page=20&page=${page}&is_retail_automation_template=true`;
  const listData = await apiGet(addTimestampParamInUrl(url));

  if (!listData) return [];

  const IMAGINE_RETAIL_STORE = 'Imagine Retail Store';
  const RETAIL_STORE = 'Retail Store';
  const DRUG_STORE = 'Drug Store';

  const STORE_NAMES = {
    2945: IMAGINE_RETAIL_STORE,
    2702: IMAGINE_RETAIL_STORE,
    2992: RETAIL_STORE,
    2347: RETAIL_STORE,
    4993: DRUG_STORE,
  };

  // Merge old and new templates
  const oldLists = selectAllTemplates(getAppState());
  const list = [
    ...oldLists,
    ...listData.results, // filtering only the silo room template
  ]
    .map((val) => ({
      ...val,
      name: STORE_NAMES[val.id] || val.name, // fallback to existing name
    }))
    ?.filter((a) => a.room_type === ROOM_TYPE.SILO)
    ?.slice(0); // filtering only the first silo templates as we will be using the silo template in the retail

  // Update store
  dispatch(retailAutomationActions.setAllTemplates(list));

  // Clone listData without results
  const { results, ...meta } = listData;
  dispatch(retailAutomationActions.setTemplateApiData({ ...meta, count: list.length })); // here, setting the count value to the length of the list because above we are filtering the template and if the count is different then it refetching the next page

  return listData;
};

export const getAllSets = async (id) => {
  const url = `${CRUD_RETAIL_AUTOMATION_SETS}?retail_automation=${id}`;
  // TODO: add error handling
  const sets = await apiGet(addTimestampParamInUrl(url));
  if (sets) {
    return sets?.results;
  } else {
    return {};
  }
};

export const createRetailAutomationSet = (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_SETS}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const deleteRetailAutomationSetApi = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_SETS;
  url += `${id}`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const updateRetailAutomationSets = (data, oldData) => async (dispatch) => {
  const url = `${CRUD_RETAIL_AUTOMATION_SETS}${data.id}/`;
  try {
    const updatedData = await apiPatch(url, data, 'updateRetailAutomationSets');
    if (!updatedData) {
      throw new Error();
    }
    return updatedData;
  } catch (error) {
    errorToastV2('Something went wrong! please try again.');
  }
};

export const getAllHotspotApis = async ({ retailAutomationId, retailSetId }) => {
  const url = `${CRUD_RETAIL_AUTOMATION_HOTSPOT}?retail_automation=${retailAutomationId}&retail_set=${retailSetId}`;
  // TODO: add error handling
  const hotspots = await apiGet(addTimestampParamInUrl(url));
  if (hotspots) {
    return hotspots?.results;
  } else {
    return {};
  }
};

export const apiCreateHotspot = async (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_HOTSPOT}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const deleteHotspotApi = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_HOTSPOT;
  url += `${id}`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const updateHotspotApi = (data, oldData) => async (dispatch) => {
  const url = `${CRUD_RETAIL_AUTOMATION_HOTSPOT}${data.id}/`;
  try {
    const updatedData = await apiPatch(url, data, 'updateRetailAutomationHotspot');
    if (!updatedData) {
      throw new Error();
    }
    return updatedData;
  } catch (error) {
    errorToastV2('Something went wrong! please try again.');
  }
};

// CREATED NEW FN in HELPER FILE
// export const updateHotspotJsonApi = (data, oldData) => async (dispatch) => {

//   const presignedFormData = new FormData();
//   presignedFormData.append("hotspot", data.id);
//   presignedFormData.append("json_file_name", "hotspot_json.json");

//   let result = null;

//   try {
//     const presignedData = await apiPost(CRUD_RETAIL_AUTOMATION_HOTSPOT_PRESIGNED, presignedFormData, 'apiPostHotspotPresignedData', null, null, true);

//     if(!presignedData?.status) {
//       errorToast('Unable to update the hotspot json.');
//       throw new Error();
//     }

//     if (data?.json_file && presignedData?.data?.presigned_data) {
//       result = await apiPostImageOnPresignedData(data?.json_file, presignedData?.data?.presigned_data)
//       .then(async res => {

//         if(res) {
//           const updatePayload = { json_file_url: presignedData?.data?.key };
//           return await apiPatch(`${CRUD_RETAIL_AUTOMATION_HOTSPOT_UPDATE}${data.id}/`, updatePayload, 'apiPatchHotspotJsonData', null, null, true);
//         }
//         return null;
//       });
//     }

//     return result;
//   } catch (error) {
//     errorToastV2('Something went wrong! please try again.');
//     return result;
//   }
// };

export const createCameraViaApi = async (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_CAMERA}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const createBulkCameraViaApi = async (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_BULK_CAMERA}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

export const getAllHotspotCameras = async ({ hotspot, retail_set }) => {
  const url = `${CRUD_RETAIL_AUTOMATION_CAMERA}?retail_set=${retail_set}&hotspot=${hotspot}`;
  // TODO: add error handling
  const cameras = await apiGet(addTimestampParamInUrl(url));
  if (cameras) {
    return cameras?.results;
  } else {
    return {};
  }
};

export const getPropVariantListingFromApi = async (propId) => {
  const url = `${RETAIL_AUTOMATION_PROP_VARIANT_LISTING}?prop_id=${propId}`; // RETAIL_AUTOMATION_PROP_VARIANT_V2

  // TODO: add error handling
  const product = await fetchAllPages(
    async (page) => await apiGet(addTimestampParamInUrl(url + `&page=${page}`))
  );
  if (product) {
    return product?.results;
  } else {
    return {};
  }
};

export const getPropVariantFromApi = async (propId) => {
  clearCacheFromAPI();
  const url = `${RETAIL_AUTOMATION_PROP_VARIANT_V2}?prop_id=${propId}`; // RETAIL_AUTOMATION_PROP_VARIANT_V2

  // TODO: add error handling
  const [product, listing] = await Promise.all([
    apiGet(addTimestampParamInUrl(url)),
    getPropVariantListingFromApi(propId),
  ]);
  if (product) {
    return product?.results.map((a) => ({
      ...a,
      product_variants_data: listing || [],
    }));
  } else {
    return {};
  }
};

export const deleteCameraApi = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_CAMERA;
  url += `${id}`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const updateCameraApi = (data, oldData) => async (dispatch) => {
  const url = `${CRUD_RETAIL_AUTOMATION_CAMERA}${data.id}/`;
  try {
    const updatedData = await apiPatch(url, data, 'UpdateRetailAutomationCamera');
    if (!updatedData) {
      throw new Error();
    }
    return updatedData;
  } catch (error) {
    errorToastV2('Something went wrong! please try again.');
  }
};

export function apiGetCollection(
  { type, perPage = 20, page = 1, search } = {},
  successMessage = null,
  errorMessage = null
) {
  let query = `per_page=${perPage}&page=${page}`;
  if (type) {
    query += `&type=${type}`;
  }
  if (search) {
    query += `&search=${search}`;
  }
  return apiGet(
    addTimestampParamInUrl(`${COLLECTION_DETAILS_API}?${query}`),
    'apiGetCollection',
    successMessage,
    errorMessage
  );
}

export const apiCreateArtworkCombination = async (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_ARTWORK}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const apiGetArtworkCombinations = async ({
  payload: { hotspot, retail_set, product },
  saveData = true,
  filterList = true,
}) => {
  let url = `${CRUD_RETAIL_AUTOMATION_ARTWORK}?retail_set=${retail_set}&hotspot=${hotspot}`;
  if (product) {
    url += `&product=${product}`;
  }
  // TODO: add error handling
  const combinations = await apiGet(addTimestampParamInUrl(url));
  if (combinations) {
    let dataRec = JSON.parse(JSON.stringify(combinations?.results)) || [];
    if (filterList) {
      dataRec = dataRec?.filter((val) => !val.is_default);
    }
    if (saveData) {
      dispatcher(retailAutomationActions.setCurrentArtWorkCombinations(dataRec));
      // await wait(1000);
      dispatcher(retailAutomationActions.setCombinationLoaded(true));
    }
    return dataRec;
  } else {
    return {};
  }
};

export const apiGetArtworkTextures = async ({ retail_set, retail_hotspot, artwork }, dispatch) => {
  const url = `${CRUD_RETAIL_AUTOMATION_ARTWORK_TEXTURE}?retail_set=${retail_set}&hotspot=${retail_hotspot}&artwork=${artwork}&per_page=${20}`;
  // TODO: add error handling
  const textures = await fetchAllPages(
    async (page) => await apiGet(addTimestampParamInUrl(url + `&page=${page}`))
  );
  if (textures) {
    return textures?.results || [];
  } else {
    return [];
  }
};

export const getAllHotspotProducts = async ({ hotspot, retail_set }) => {
  // retail_set=${retail_set}&
  const url = `${CRUD_RETAIL_AUTOMATION_PRODUCTS}?hotspot=${hotspot}`;
  // TODO: add error handling
  const products = await apiGet(addTimestampParamInUrl(url));
  if (products) {
    return products?.results;
  } else {
    return {};
  }
};

export const createProductViaApi = async (payload) => {
  const url = CRUD_RETAIL_AUTOMATION_PRODUCTS;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const addProductViaApi = async (payload) => {
  const url = CRUD_RETAIL_AUTOMATION_PRODUCTS_V2;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

export const deleteProductsApi = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_PRODUCTS;
  url += `${id}/`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const updateProductApi = async ({ id, payload }) => {
  const url = `${CRUD_RETAIL_AUTOMATION_PRODUCTS}${id}/`;
  const result = await apiPatch(url, payload);
  if (!result?.data) {
    errorToastV2('Something went wrong. Please try again.');
    return;
  }
  return result?.data;
};

export const saveArtworkTexture = async (payload) => {
  const url = `${CRUD_RETAIL_AUTOMATION_ARTWORK_TEXTURE}`;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const deleteArtworkApi = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_ARTWORK;
  url += `${id}`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const duplicateArtworkApi = async (payload) => {
  let url = DUPLICATE_ARTWORK;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const createCollectionApi = async (payload) => {
  let url = COLLECTION_DETAILS_API;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
  }).send();
};

export const createARender = async (payload) => {
  let url = RENDER_ARTWORK;
  const data = payload;
  let payloadToPass = new FormData();
  payloadToPass.append('retail_set_id', payload.retail_set_id);
  payloadToPass.append('hotspot_id', payload.hotspot_id);
  payloadToPass.append('collection_id', payload.collection_id);
  payloadToPass.append('is_main_render', payload.is_main_render);
  payloadToPass.append('is_greyscale_render', payload.is_greyscale_render);
  payload.identifier_data.map((data) => {
    payloadToPass.append('identifier_data', JSON.stringify(data));
  });
  const result = await apiPostV2(url, {
    data: payloadToPass,
  }).send();
  return result;
};

export const updateRetailAutomationArtwork = async (data, oldData) => {
  const url = `${CRUD_RETAIL_AUTOMATION_ARTWORK}${data.id}/`;
  try {

    let _data = {}

    if(data?.json_file) {
      _data = {
        id: data.id,
        json_file: "artwork_json.json"
      }
    } else {
      _data = data;
    }

    const response = await apiPatch(url, _data, 'updateRetailAutomationArtwork');
    if (!response || !response?.status) {
      throw new Error();
    }

    if (data?.json_file && response?.data?.presigned_data_json_file) {
      apiPostImageOnPresignedData(data?.json_file, response?.data?.presigned_data_json_file);
    }

    return response;
  } catch (error) {
    errorToastV2('Something went wrong! please try again.');
  }
};

export const deleteMultipleRetailAutomationApi = (
  payload,
  successMessage = 'Retail automations deleted successfully',
  errorMessage = 'Unable to delete retail automations: Renders in progress'
) => {
  const formdata = new FormData();
  let id;
  for (var pair of payload.entries()) {
    if (!id) {
      id = pair[1];
    }
    formdata.append('automation_id', pair[1]);
  }

  for (var pair1 of formdata.entries()) {
    console.log(pair1[0], pair1[1], 'check for multi delete');
  }

  return apiMultiDelete(
    CRUD_RETAIL_AUTOMATION + id,
    formdata,
    'apiDeleteRetailAutomation',
    successMessage,
    errorMessage
  );
};

export const deleteTextureForAutomation = async (id) => {
  let url = CRUD_RETAIL_AUTOMATION_ARTWORK_TEXTURE;
  url += `${id}`;
  const result = await apiDeleteV2(url, {
    showErrorToast: false,
  })
    .data()
    .send();
  return result;
};

export const apiCreateMultiTexture = async (payload) => {
  let url = CREATE_MULTI_TEXTURE_RETAIL_AUTO;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

export const apiUpdateMultiTexture = async (id, payload) => {
  const url = `${CREATE_MULTI_TEXTURE_RETAIL_AUTO}${id}/`;

  try {
    const updatedData = await apiPatch(url, payload, 'updateMultiTexture', null, null, false);
    if (!updatedData) {
      throw new Error();
    }
    return updatedData;
  } catch (error) {
    errorToastV2('Something went wrong! please try again.');
  }
};

export const apiDeleteMultipleTextures = async (payload, id) => {
  let url = CREATE_MULTI_TEXTURE_RETAIL_AUTO;
  url += `${id}/`;
  const formdata = new FormData();
  formdata.append('retail_set', payload.retail_set);
  formdata.append('texture_ids', JSON.stringify(payload.textureIds));
  return apiMultiDelete(url, formdata, 'apiDeleteMultipleTextures');
};

export const duplicateMultipleTextures = async (payload, id) => {
  let url = DUPLICATE_MULTI_TEXTURE_RETAIL_AUTO;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

export const saveArtworkProduct = async (payload) => {
  return apiPost(PROP_GROUP_API_V2, payload, 'saveArtworkProduct', null, null, true)
};

export const updateVariantToProductApi = async ({ id, payload }) => {
  const url = UPDATE_PROPS_API.replace(':productId', `${id}/`);
  const result = await apiPatch(url, payload, null, null, null, false);
  if (!result?.data) {
    errorToastV2('Something went wrong. Please try again.');
    return;
  }
  return result?.data;
};

export const duplicateArtworkProduct = async (payload, id) => {
  let url = DUPLICATE_HOTSPOT_PRODUCT;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: true,
    showMessage: false
  }).send();
};

export const propsReadApiV2 = async (arr = [], page = 1, params=null) => {
  let query = arr.map((a) => `id=${a}`).join("&");
  if (params)
    query += `&${params}`;
  return await api()
    .root(API_ROOT_URL)
    .get(addTimestampParamInUrl(`${PROPS_API_V2}?${query}&per_page=20&page=${page}`))
    .send();
};